import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./ConstNeed.css";

import { FiArrowUpRight } from "react-icons/fi";
import { usePageContent } from "../../../../hooks/usePublicQueries";
import {
  getOurSolutionDisplayCards,
  getOurSolutionSectionFromHome,
} from "../../../../utils/ourSolutionCards";

const ConstNeed = () => {
  const { t, i18n } = useTranslation();
  const { data: homeContent } = usePageContent("home", i18n.language);

  const displaySolutions = useMemo(() => {
    const section = getOurSolutionSectionFromHome(homeContent);
    return getOurSolutionDisplayCards(section);
  }, [homeContent]);

  return (
    <section className="constNeed">
      <div className="constNeed-inner">
        <div className="constNeed-header">
          <span className="constNeed-tag">{t("sections.allSolutions.constNeed.tag")}</span>

          <h2 className="constNeed-title">
            {t("sections.allSolutions.constNeed.titleLine1")}
            <br />
            {t("sections.allSolutions.constNeed.titleLine2")}{" "}
            <span className="constNeed-titleAccent">
              {t("sections.allSolutions.constNeed.titleAccent")}
            </span>
          </h2>

          <p className="constNeed-intro">{t("sections.allSolutions.constNeed.intro")}</p>
        </div>

        <div className="constNeed-cards">
          {displaySolutions.map((item) => (
            <Link
              className="constNeed-card"
              key={item.key}
              to={item.link}
            >
              <div className="constNeed-cardTop">
                <div className="constNeed-cardIcon">
                  <img src={item.icon} alt="" draggable={false} />
                </div>
              </div>

              <div className="constNeed-cardBottom">
                <h3>{item.title}</h3>

                <p>{item.description}</p>

                <div className="constNeed-more">
                  {t("sections.allSolutions.constNeed.moreDetails")} <FiArrowUpRight />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ConstNeed;
